
export interface ElasticSearchIndex {
    indexName: string;
    documentIdProperty: string;
    insertOnlyMode: boolean;
}
